import * as _ from 'lodash-es';
import React from 'react';
import type { ApolloError } from '@apollo/client';
import ExternalBrandLogo from '../../components/ExternalBrandLogo';
import getExternalBrandLogoProps from '../../integrations/getExternalBrandLogoProps';
import Link from '../../utils/router/Link';
import useIntegrationErrorHandlerData from '../useIntegrationErrorHandlerData';
import * as styles from './EmbedFallback.module.scss';
import { EmbedMode, embedUrl } from './matchEmbed';

interface EmbedFallbackProps {
  id: string;
  type: string;
  refetch: () => unknown;
  error?: ApolloError;
}

const EmbedFallback = ({ id, type, refetch, error }: EmbedFallbackProps) => {
  const { handlerProps } = useIntegrationErrorHandlerData({
    mode: 'mention',
    type,
    view: 'hoverCard',
    refetch,
    error,
    buttonVariant: 'secondary',
    buttonSize: 'large',
  });

  if (!handlerProps) {
    return (
      <Link
        className={styles.fallback}
        to={embedUrl({ id, type }, EmbedMode.FULL) || '#'}
        newTab="ugc"
      >
        <ExternalBrandLogo {...getExternalBrandLogoProps(type)} height={64} />
        <h3 className={styles.title}>No preview available</h3>
        <div className={styles.message}>
          Click anywhere in this frame to view in{' '}
          {_.capitalize(type.split('-')[0])}.
        </div>
      </Link>
    );
  }

  return (
    <div className={styles.fallback}>
      <ExternalBrandLogo {...getExternalBrandLogoProps(type)} height={64} />
      <h3 className={styles.title}>{handlerProps.title}</h3>
      <div className={styles.message}>{handlerProps.message}</div>
      {handlerProps.primaryButton && (
        <div className={styles.button}>{handlerProps.primaryButton}</div>
      )}
    </div>
  );
};

export default EmbedFallback;
